require('./global/announcements.js');
require('./global/sticky-header.js');
require('./global/language-switcher.js');
require('./global/menu.js');
require('./global/scroll-link.js');
require('./global/link.js');
require('./global/search.js');
require('./components/logos.js');
require('./components/accordion.js');
require('./components/animating_text.js');
require('./components/image.js');
require('./components/video-modal.js');
require('./components/modal.js');
require('./components/video.js');
require('./components/testimonials.js');
require('./components/quilt.js');
// require('./components/footer-dropdowns.js');
// require('./global/third-party.js');